import { TDataTableColumnsData } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { EABTestsNav } from "../types"

export type TGetColumnsDataProps = {
    tabFilter: EABTestsNav
}

export function getColumnsData({ tabFilter }: TGetColumnsDataProps): () => TDataTableColumnsData[] {
    const baseColumns: TDataTableColumnsData[] = [
        {
            id: "name",
            label: t("general-name"),
            sortable: true
        },
        {
            id: "list_id",
            label: t("general-list_one"),
            sortable: true
        }
    ]

    // Active tab: Show pathA vs pathB comparison
    if (tabFilter === EABTestsNav.Active) {
        return () => [
            ...baseColumns,
            {
                id: "pathA_click_rate",
                label: `A - ${t("general-click_rate")}`,
                sortable: false
            },
            {
                id: "pathA_unsubscribe_rate",
                label: `A - ${t("general-unsubscribe_rate")}`,
                sortable: false
            },
            {
                id: "pathA_bounce_rate",
                label: `A - ${t("general-bounce_rate")}`,
                sortable: false
            },
            {
                id: "pathB_click_rate",
                label: `B - ${t("general-click_rate")}`,
                sortable: false
            },
            {
                id: "pathB_unsubscribe_rate",
                label: `B - ${t("general-unsubscribe_rate")}`,
                sortable: false
            },
            {
                id: "pathB_bounce_rate",
                label: `B - ${t("general-bounce_rate")}`,
                sortable: false
            },
            {
                id: "actions",
                label: ""
            }
        ]
    }

    // Completed tab: Show winner stats
    if (tabFilter === EABTestsNav.Completed) {
        return () => [
            ...baseColumns,
            {
                id: "winner_click_rate",
                label: t("general-click_rate"),
                sortable: false
            },
            {
                id: "winner_unsubscribe_rate",
                label: t("general-unsubscribe_rate"),
                sortable: false
            },
            {
                id: "winner_bounce_rate",
                label: t("general-bounce_rate"),
                sortable: false
            },
            {
                id: "actions",
                label: ""
            }
        ]
    }

    // Draft tab: Standard columns
    return () => [
        ...baseColumns,
        {
            id: "created_on",
            label: t("general-created_on"),
            sortable: true
        },
        {
            id: "updated_on",
            label: t("general-updated_on"),
            sortable: true
        },
        {
            id: "actions",
            label: ""
        }
    ]
}
